import React, { useMemo } from "react";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useSelector } from "react-redux";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import { extractDateFromStr, getLatestUpdatedObject } from "../../Utils/utils";
import Loader from "../../components/Loader";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const CovidComponent = () => {
  const { getText } = useLanguageTranslation();

  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: covid19Html = {}, isLoading: covid19HtmlIsLoading } =
    useGetHtmlApiQuery({ url: 154, lang: languageType });

  const { data: covid19Data = [], isLoading: covid19DataIsLoading } =
    useGetProtectedApiDataQuery({ url: "covid", lang: languageType });

  useTableResponsive(covid19Data);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(covid19Data)?.changed);
  }, [covid19Data]);

  const pageBody = covid19Html?.body?.[0]?.value ?? "No content available";
  const pageTitle = covid19Html?.title?.[0]?.value ?? "No Title available";

  if (covid19HtmlIsLoading && covid19DataIsLoading) {
    return <Loader />;
  }
  return (
    <>
      {/* <PageLastUpdated lastUpdatedOn={lastUpdatedOn} /> */}
      <div className="row mb-5">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
          <div className="title-sec">
            <h2>{pageTitle}</h2>
          </div>
          <div className="about_inntxt">
            <p dangerouslySetInnerHTML={{ __html: pageBody }}></p>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
          <div className="table-responsive">
            <table className="table table-striped custom-table">
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "56px" }}>
                    {getText("S.No.", "क्र. सं.")}
                  </th>
                  <th>{getText("Title", "शीर्षक")}</th>
                  <th>{getText("Attachment", "संलग्नक")}</th>
                </tr>
              </thead>
              <tbody>
                {covid19Data.map((item, index) => (
                  <tr key={index}>
                    <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                    <td data-key={getText("Title", "शीर्षक")}>{item.title}</td>
                    <td data-key={getText("Attachment", "संलग्नक")}>
                      <a
                        href={`${process.env.REACT_APP_IMAGE_URL}/${item?.field_covid_document}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="pdf-icon">
                          <img
                            src="./images/pdf-icon.png"
                            alt="pdf-icon"
                            className="mr-2"
                          />
                        </div>
                      </a>
                      <span> ({item.filesize})</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CovidComponent;
